import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Activity, Moon } from 'lucide-react';
export function MechanismSection() {
  const pillars = [{
    letter: 'A',
    title: 'Anti-inflamación',
    desc: 'Comidas simples, “seguras”, con swaps que no te complican.',
    icon: ShieldCheck,
    color: 'bg-teal text-white'
  }, {
    letter: 'I',
    title: 'Insulina estable',
    desc: 'El desayuno ancla y el snack puente que evitan el colapso nocturno.',
    icon: Activity,
    color: 'bg-gold text-white'
  }, {
    letter: 'R',
    title: 'Recuperación',
    desc: 'Mínimos reales para bajar el “modo defensa” (sin mística, sin rutinas imposibles).',
    icon: Moon,
    color: 'bg-warm-gray text-white'
  }];
  return <section className="w-full bg-teal-light py-20 px-4 md:px-6" data-id="element-117">
      <div className="max-w-5xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-119">
          <h2 className="text-3xl md:text-5xl font-bold text-teal-dark mb-4" data-id="element-120">
            Presento: Menopausia Sin Castigo
          </h2>
          <p className="text-xl text-teal-dark/80 mb-8 font-serif italic" data-id="element-121">
            Reset Anti-Inflamación 21 días
          </p>
          <p className="text-lg text-warm-dark max-w-3xl mx-auto mb-8" data-id="element-122">
            Un PDF práctico (cocina de 10 minutos) para mujeres 35+ en USA que
            están cansadas de intentar “más fuerte” y quieren un sistema que el
            cuerpo por fin acepte.
          </p>

          <div className="bg-white/60 inline-block p-6 rounded-xl backdrop-blur-sm border border-teal/10" data-id="element-123">
            <p className="text-warm-gray italic" data-id="element-124">
              Esto no es una dieta extrema. No es un reto de sufrimiento. No es
              “cero carbohidratos” ni “vive a ensaladas”.
              <br data-id="element-125" />
              <span className="font-medium text-teal-dark not-italic mt-2 block" data-id="element-126">
                Es un reset que hace algo más inteligente: cambia las señales
                que recibe tu cuerpo.
              </span>
            </p>
          </div>
        </motion.div>

        {/* Triángulo A.I.R. */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-127">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-md border border-teal/5 relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-128">
              <div className={`absolute top-0 right-0 w-24 h-24 -mr-8 -mt-8 rounded-full opacity-10 ${pillar.color}`} data-id="element-129"></div>
              <div className={`w-12 h-12 rounded-lg ${pillar.color} flex items-center justify-center mb-6 shadow-sm`} data-id="element-130">
                <span className="font-bold text-xl" data-id="element-131">{pillar.letter}</span>
              </div>
              <h3 className="text-xl font-bold text-warm-dark mb-3" data-id="element-132">
                {pillar.title}
              </h3>
              <p className="text-warm-gray leading-relaxed" data-id="element-133">{pillar.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-134">
          <p className="text-2xl md:text-3xl font-serif text-teal-dark font-medium max-w-3xl mx-auto leading-tight" data-id="element-135">
            “Cuando estas 3 piezas se alinean, pasa algo que muchas mujeres no
            han sentido en años: el cuerpo deja de pelearte.”
          </p>
        </motion.div>
      </div>
    </section>;
}